<template>
<div>
    <v-card class="mx-auto">
      <v-card-title>IoT MAC Address Registration</v-card-title>
      <v-card-text>
        For more information click <a href="http://cmu.to/ipsk" target="_blank">here</a>
      </v-card-text>
    </v-card>
<div class="ma-5"></div>
  <v-btn
      large
      color="primary"
      :href="loginUrl"
    >
      Log in with CMU IT Account
    </v-btn>
</div>
</template>

<script>
import Vue from 'vue';
import randomstring from "randomstring";
import CryptoJS from 'crypto-js';

export default Vue.extend({
  data: () => ({
    loginUrl: ''
  }),
  mounted () {
    const auth_url = this.$store.state.auth_url
    const app_id = this.$store.state.app_id
    const callback_url = this.$store.state.callback_url
    const scope = this.$store.state.scope

    const code_verifier = randomstring.generate(64)
    sessionStorage.setItem('code_verifier',code_verifier)
    const code_challenge =  CryptoJS.SHA256(code_verifier).toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
    //console.log(code_verifier, code_challenge);
    this.loginUrl=`${auth_url}?client_id=${app_id}&redirect_uri=${callback_url}&response_type=code&code_challenge_method=S256&code_challenge=${code_challenge}&scope=${scope}`
  }  
});
</script>
